import serialize from './serialize';
import flatten from './flatten';
import enrich from './enrich';
import payload from './payload';

/**
 * Generates a copy of an error record, enriching it with extra metadata, serializing it, and flattening nested keys.
 * @param {ErrorRecord} record The error record to format.
 * @return {ErrorRecord}
 */
const formatError = (record, enrichment) => [
    serialize,
    flatten,
    enrich,
    (obj) => Object.assign(obj, enrichment),
    payload,
    JSON.stringify
].reduce((acc, fn) => fn(acc), record);

export default formatError;
